<template>
	<div class="navigation">
		<div>
			<div class="top-wrapper">
				<MenuIcon @click="toggleNavBar" class="toggle-menu-icon" v-if="navBarVisibility" />
				<h2 class="dashboard-title" v-if="assignUserStatus">Assign Student</h2>
				<h2 class="dashboard-title" v-if="navBarVisibility && !assignUserStatus">{{ transformedTitle }}</h2>
			</div>
			<h4 class="navigation-title">Users</h4>
			<router-link class="nav-item" to="/?page=1" @click.native="toggleBar">All Users</router-link>
			<h4 class="navigation-title">Content</h4>
			<router-link class="nav-item" to="/templates?page=1" @click.native="toggleBar">Course Templates</router-link>
			<router-link class="nav-item" to="/courses?page=1" @click.native="toggleBar">My Courses</router-link>
		</div>
		<div>
			<a href="#" class="nav-item sign-out" @click.prevent="signOut">Sign Out <span><exit-to-app class="navigation-button-icon"/></span></a>
		</div>
	</div>
</template>

<script>
import MenuIcon from 'vue-material-design-icons/Menu.vue'
import ExitToApp from 'vue-material-design-icons/ExitToApp.vue'

export default {
	props: ['navBarVisibility', 'title', 'assignUserStatus'],
	name: "nav-bar",
	components: {
		MenuIcon,
		ExitToApp
	},
	computed: {
		transformedTitle() {
			return this.title.charAt(0).toUpperCase() + this.title.slice(1)
		},
	},
	methods: {
		toggleNavBar() {
			this.$emit('toggleNavBar');
		},
		signOut: function () {
			this.$store.dispatch('logoutUser', false)
				.then(() => {
						this.$router.push('/login');
					}
				)
		},
		toggleBar() {
			this.$emit('toggleNavBar')
		}
	}
}
</script>

<style scoped lang="scss">

.top-wrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
}


.navigation {

	.sign-out.nav-item {
		display: flex;
		align-items: center;

		span {
			margin-left: 5px;
		}
	}


	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;

	.toggle-menu-icon {
		color: #0275ff;
		background-color: rgba(0,116,255,.05);
		border-radius: 50%;
		padding: 0;
		height: 50px;
		width: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
	}
	text-align: left;

	.home-navigation {
		background-color: white;

		a {
			color: #35495e;
		}

		display: block;

		h2 {
			padding: 25px 15px;
			margin: 0;
		}
	}

	.navigation-title {
		font-weight: 700;

		&:first-of-type {
			margin-top: 80px;
		}

		margin-top: 30px;
		margin-left: 10px;
	}

	.nav-item {
		padding: 10px 0 10px 10px;
		display: block;
	}
}
.dashboard-title {
	font-weight: bold;
}
.toggle-menu-icon {
	cursor: pointer;
}

</style>
